export enum ImageUploadMode {
    Upload = 0,
    Edit = 1,
    View = 2
  }
  